import {
  IAdministrator,
  IVehicle,
} from '@boma/supplier-portal/shared/entities';

import {
  IAssignedAdminRoles,
  IPaginatedResponse,
  IRole,
} from '@boma/client-shared';
import { createAction, props } from '@ngrx/store';

export const loadVehicles = createAction(
  '[Vehicles] Load Vehicles',
  props<{ query: string; page?: number }>()
);

export const loadVehiclesSuccess = createAction(
  '[Vehicles] Load Vehicles Success',
  props<{ payload: IPaginatedResponse<IVehicle> }>()
);

export const loadVehiclesFailure = createAction(
  '[Vehicles] Load Vehicles Failure',
  props<{ error: any }>()
);

export const searchVehicles = createAction(
  '[Vehicles] Search Vehicles',
  props<{ query: string }>()
);

export const searchVehiclesSuccess = createAction(
  '[Vehicles] Search Vehicles Success',
  props<{ payload: IPaginatedResponse<IVehicle> }>()
);

export const searchVehiclesFailure = createAction(
  '[Vehicles] Search Vehicles Failure',
  props<{ error: any }>()
);

export const createVehicle = createAction(
  '[Vehicles] Create Vehicle',
  props<{ vehicle: IVehicle }>()
);

export const createVehicleSuccess = createAction(
  '[Vehicles]  Create Vehicle Success',
  props<{ vehicle: IVehicle }>()
);

export const createVehicleFailure = createAction(
  '[Vehicles]  Create Vehicle Failure',
  props<{ error: any }>()
);

export const loadVehicle = createAction(
  '[Vehicles] Load Vehicle',
  props<{ id: string }>()
);

export const loadVehicleSuccess = createAction(
  '[Vehicles] Load Vehicle Success',
  props<{ vehicle: IVehicle }>()
);

export const loadVehicleFailure = createAction(
  '[Vehicles] Load Vehicle Failure',
  props<{ error: any }>()
);

export const updateVehiclePermissions = createAction(
  '[Vehicles] Update Vehicle Permissions',
  props<{
    entityId: string;
    vehicleId: string;
    userId: string;
    roleIds: string[];
  }>()
);

export const updateVehiclePermissionsSuccess = createAction(
  '[Vehicles] Update Vehicle Permissions Success',
  props<{ payload: IAssignedAdminRoles }>()
);

export const updateVehiclePermissionsFailure = createAction(
  '[Vehicles] Update Vehicle Permissions Failure',
  props<{ error: any }>()
);

export const updateVehicle = createAction(
  '[Vehicles] Update Vehicle',
  props<{ vehicle: IVehicle }>()
);

export const updateVehicleSuccess = createAction(
  '[Vehicles]  Update Vehicle Success',
  props<{ vehicle: IVehicle }>()
);

export const updateVehicleFailure = createAction(
  '[Vehicles]  Update Vehicle Failure',
  props<{ error: any }>()
);

export const loadAdministrators = createAction(
  '[Vehicles] Load Administrators',
  props<{ vehicleId: string; query: string }>()
);

export const loadAdministratorsSuccess = createAction(
  '[Vehicles] Load Administrators Success',
  props<{ administrators: IAdministrator[] }>()
);

export const loadAdministratorsFailure = createAction(
  '[Vehicles] Load Administrators Failure',
  props<{ error: any }>()
);

export const loadAdministratorDetails = createAction(
  '[Vehicles] Load Administrator',
  props<{ adminId: string; vehicleId: string }>()
);

export const loadAdministratorDetailsSuccess = createAction(
  '[Vehicles] Load Administrator Success',
  props<{ administrator: IAdministrator }>()
);

export const loadAdministratorDetailsFailure = createAction(
  '[Vehicles] Load Administrator Failure',
  props<{ error: any }>()
);

export const loadRoles = createAction('[Vehicles] Load Roles');

export const loadRolesSuccess = createAction(
  '[Vehicles] Load Roles Success',
  props<{ payload: IPaginatedResponse<IRole> }>()
);

export const loadRolesFailure = createAction(
  '[Vehicles] Load Roles Failure',
  props<{ error: any }>()
);

export const deleteAdministrator = createAction(
  '[Vehicles] Delete Administrator',
  props<{ userId: string; vehicleId: string }>()
);

export const deleteAdministratorSuccess = createAction(
  '[Vehicles] Delete Administrator Success',
  props<{ userId: string }>()
);

export const createAdministrator = createAction(
  '[Vehicles] Create Administrator',
  props<{
    vehicleId: string;
    emailAddressOrPhoneNumber: string;
    roleIds: string[];
  }>()
);

export const createAdministratorSuccess = createAction(
  '[Vehicles] Create Administrator Success',
  props<{ administrator: IAdministrator }>()
);

export const updateAdministrator = createAction(
  '[Vehicles] Update Administrator',
  props<{ vehicleId: string; userId: string; roleIds: string[] }>()
);

export const updateAdministratorSuccess = createAction(
  '[Vehicles] Update Administrator Success',
  props<{ administrator: IAdministrator }>()
);

export const updatePerPage = createAction(
  '[Vehicles]  Update Per Page',
  props<{ perPage: number }>()
);
